class ServidorUtils {
    isServidorEmManutencao() {
        return process.env.VUE_APP_MANUTENCAO.toUpperCase() === "TRUE";
    }
}

export const servidorUtils = new ServidorUtils()